import { IChangeLogHistoryGridRow } from '@/Interfaces/ChangeLogHistory.interface';
import TableActionButton from '@/components/Buttons/TableActionButton';
import { GridRenderCellParams } from '@mui/x-data-grid-pro';
import { useState } from 'react';
import AuditLogChangesModal from './AuditLogChangesModal';

const ActionCell = ({ row }: GridRenderCellParams<IChangeLogHistoryGridRow>) => {
  const [open, setOpen] = useState(false);

  if (!row.hasChanges) return null;

  return (
    <>
      <TableActionButton variant='outlined' color='primary' onClick={() => setOpen(true)}>
        <span>View Changes</span>
      </TableActionButton>
      <AuditLogChangesModal open={open} onClose={() => setOpen(false)} auditLogId={row.id} summary={row.summary} />
    </>
  );
};

export default ActionCell;
